import React from 'react';

export type ContextMethodsType = {
  setCreateOrUpdate: (vale: SectionContextType['createOrUpdate']) => void;
  setTrash: (vale: SectionContextType['trash']) => void;
  setDepartmentId: (id: number) => void;
};

export type SectionContextType = {
  createOrUpdate: {
    visible: boolean;
    name?: string;
    id?: number;
  };

  trash: {
    employees?: {
      id: number;
      fullName: string;
      avatar?: string;
      status: 'ENABLED' | 'DISABLED';
    }[];
    departmentId?: number;
    visible: boolean;
    id?: number;
  };

  methods: ContextMethodsType;
};

const emptyFn = () => {};

const Context = React.createContext<SectionContextType>({
  createOrUpdate: {
    visible: false
  },

  trash: {
    visible: false
  },

  methods: {
    setCreateOrUpdate: emptyFn,
    setTrash: emptyFn,
    setDepartmentId: emptyFn
  }
});

export default Context;
